import type { NuxtApp } from '#app'

export const pendingIdentityLoads = new WeakMap<NuxtApp, Promise<void>>()
